import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { colours } from '../theme';
import { StatusLabel, type StatusTone } from './StatusLabel';

/** A row of big numbers: a near-black rule above, hairlines between. */
export function StatStrip({ columns, children }: { columns: number; children: ReactNode }) {
  return (
    <Box sx={{ borderTop: `2px solid ${colours.nearBlack}`, display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: `repeat(${columns}, minmax(0, 1fr))` }, mb: 5 }}>
      {children}
    </Box>
  );
}

/** One number in a StatStrip. A tone shows the label as a status (dot and word). null value: loading. */
export function Stat({ tone, label, value, unit, sub }: { tone?: StatusTone; label: string; value: number | string | null; unit?: string; sub: ReactNode }) {
  return (
    <Box sx={{ py: 2.5, px: { xs: 0, md: 3 }, '&:first-of-type': { pl: 0 }, borderLeft: { md: `1px solid ${colours.hairline}` }, '&:first-of-type ': { borderLeft: 0 }, minWidth: 0 }}>
      {tone ? <StatusLabel tone={tone}>{label}</StatusLabel> : <Typography sx={{ fontWeight: 500, color: colours.graphite }}>{label}</Typography>}
      <Typography className="num" sx={{ fontSize: { xs: 36, md: 44, xl: 52 }, fontWeight: 500, lineHeight: 1.1, mt: 1, whiteSpace: 'nowrap' }}>
        {value === null ? <Skeleton width={60} /> : typeof value === 'number' ? value.toLocaleString('en-AU') : value}
        {unit && value !== null && <Typography component="span" sx={{ fontSize: 18, color: colours.graphite, ml: 0.5 }}>{unit}</Typography>}
      </Typography>
      <Typography variant="body2" color="textSecondary" component="div" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={typeof sub === 'string' ? sub : undefined}>{sub}</Typography>
    </Box>
  );
}
